import React, { ReactNode } from 'react';

import Classes from './VerticalScrollList.scss';

type TProps = {
  children: ReactNode;
  className?: string;
};

const VerticalScrollListItem = ({ children, className }: TProps) => (
  <div className={`${Classes.listItem} ${className}`}>{children}</div>
);

export default VerticalScrollListItem;
